import React from 'react';

import { EmailSectionContainerWrapper } from './EmailSectionContainerWrapper';

interface EmailSectionContainerProps {
  onSubmit: (email: string, password?: string, displayName?: string, country?: string, stateCode?: string) => void;
  isLoading?: boolean;
  externalError?: string;
  onErrorClear?: () => void;
  createSubmitHandler: (
    step: 'email' | 'password',
    mode: 'login' | 'forgot' | 'register',
    email: string,
    password: string,
    displayName: string,
    country: string,
    stateCode: string,
    validateEmail: (email: string) => boolean,
    validatePassword: (password: string) => boolean,
    setStep: (step: 'email' | 'password') => void,
    onSubmit: (email: string, password?: string, displayName?: string, country?: string, stateCode?: string) => void
  ) => (e?: React.FormEvent) => void;
  createBackToEmailHandler: (
    setStep: (step: 'email' | 'password') => void,
    setPassword: (password: string) => void,
    setLocalError: (error: string | null) => void,
    onErrorClear?: () => void
  ) => () => void;
  createBackToLoginHandler: (
    setMode: (mode: 'login' | 'forgot') => void,
    setForgotSuccess: (success: boolean) => void,
    setLocalError: (error: string | null) => void,
    setForgotError: (error: string | null) => void,
    onErrorClear?: () => void
  ) => () => void;
  createSwitchModeHandler: (
    setMode: (mode: 'login' | 'forgot' | 'register') => void,
    setLocalError: (error: string | null) => void,
    onErrorClear?: () => void
  ) => (newMode: 'login' | 'register') => void;
}

export const EmailSectionContainer: React.FC<EmailSectionContainerProps> = (props) => (
  <EmailSectionContainerWrapper {...props} />
);
